import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Row
} from "reactstrap";
import i18n from "../../../i18n";
import { map } from "lodash";
import { delUsersAdminDelete } from "../../../helpers/api_rombo_helper";
import SimpleAlertError from "../../../components/Alerts/SimpleAlertError";

const DeleteBulkModal = ({ isOpen, toggle, setDeleteBulkModal, setShowAlertSuccess, checkArrUsers, setCheckArrUsers, setTextHeader, setTextBody, setReloadUsers, token, reloadUsers }) => {

  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);

  function onClickSave() {
    let body = [];
    checkArrUsers.map((checkDeleteUser, index) => {
      document.getElementById(`check-${checkDeleteUser.id}`) ? 
        document.getElementById(`check-${checkDeleteUser.id}`).checked = false : null
      body.push(checkDeleteUser.id)
    })
    delUsersAdminDelete(token, { user_ids: body })
      .then((response) => {
        setDeleteBulkModal(false)
        setCheckArrUsers([])
        setShowAlertSuccess(true)
        setTextHeader(i18n.t("DeletedUser"))
        setTextBody(i18n.t("SuccessDeletedUser"))
        setReloadUsers(!reloadUsers)
      })
      .catch((error) => {
        console.error("Error - delUsersAdminDeleteBulk ", error)
        setErrorAlertMessage((error.response?.data?.detail || error.message))
        if(error.code == 500) setErrorAlertMessage(i18n.t("NetworkError"))
        setErrorAlert(true)
      })
  }

  const cancel = () => {
    setCheckArrUsers([]);
    setDeleteBulkModal(false);
  };  
  
  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="RequestModal"
      tabIndex="-1"
      toggle={toggle}
      backdrop={'static'}
      id="staticBackdrop"
      size={"lg"}
    >
      <div>
        <p className="cancellation-title">{i18n.t("DeleteUser")}</p>
        <p className="cancellation-confirmation">{i18n.t("Confirmation")}</p>
        <div className="modal-separator"></div>
        <ModalBody className="mt-0 pt-0">
          <SimpleAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert} text={errorAlertMessage} />
          <Row>
            <p className="cancellation-text">{i18n.t("TextDeleteUser")}</p>
            {map(checkArrUsers, (checkDeleteUser, key) => (
              <h6 key={key}>
                {`- ${checkDeleteUser.full_name} (${checkDeleteUser.email})`}
              </h6>
            ))}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-danger"
            type="button"
            onClick={onClickSave}
          >
            {i18n.t("Accept")}
          </Button>
          <Button
            className="btn-light"
            type="button"
            data-dismiss="modal"
            onClick={cancel}
          >
            {i18n.t("GoBack")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

DeleteBulkModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  setDeleteBulkModal: PropTypes.func,
  setShowAlertSuccess: PropTypes.func,
  setCheckArrUsers: PropTypes.func,
  checkArrUsers: PropTypes.array,
  setTextHeader: PropTypes.func,
  setReloadUsers: PropTypes.func,
  token: PropTypes.object,
  setTextBody: PropTypes.func
}

export default DeleteBulkModal;
